export default __webpack_public_path__ + "static/media/quote.a6e89ddb.svg";